// removed by extract-text-webpack-plugin
module.exports = {"Benefits":"src-components-Benefits----style-module---Benefits---1zrMj","benefitIcon":"src-components-Benefits----style-module---benefitIcon---TqWNz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Benefits/style.module.scss
// module id = 390
// module chunks = 227585929013685